import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { iif, Observable } from 'rxjs';
import { environment } from '@shared/environments/environment';
import { CidService } from '@shared/cid/cid.service';

const allowedList = (req: HttpRequest<unknown>) => {
  return req.url.includes(`${environment.api.host}/v1`) ||
    req.url.includes(`${environment.api.host}/v2`) ||
    req.url.includes(`${environment.api.host}/auth/userinfo`) ||
    req.url.includes(`${environment.api.host}/v1`);
}

const setCidHeader = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const cidService = inject(CidService);
  const cid = cidService.get();
  const clone = req.clone({
    headers: req.headers.set('cid', cid),
  });
  return next(clone);
}

export function cidInterceptorFn(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  return iif(
    () => allowedList(req),
    setCidHeader(req, next),
    next(req),
  );
}
